<app-top-menu></app-top-menu>

<div class="justify-content-center">
  <div class="row content-row">
    <div class="p-0 banner-col">
      <img src="assets/img/self-service-payment-banner.jpg" class="self-service-payment-banner" alt />
    </div>
    <div class="form-col" style="background: #F8F8FF" *ngIf="paymentType === 'asin'">
      <!--₦-->
      <div class="d-flex flex-row align-items-center"></div>
      <h4 class="title text-decoration-underline">Pay With ASIN</h4>
      <div class="input-container">
        <form [formGroup]="verifyForm" (ngSubmit)="validateUser()" class="row g-3 m-0">
          <div class="col-md-6 tax-input-group">
            <label>ASIN </label>
            <input class="tax-form-control" formControlName="asin" />
            <app-error-message controlName="asin" label="ASIN" [form]="verifyForm"></app-error-message>
          </div>

          <div class="col-md-6 tax-input-group">
            <label>E-mail / Phone </label>
            <input class="tax-form-control" formControlName="emailOrPhone" />
            <app-error-message controlName="emailOrPhone" label="Email or phone number"
              [form]="verifyForm"></app-error-message>
          </div>

          <br />
          <div class="col-md-6 tax-input-group">
            <label>MDA</label>
            <ng-select class="ng-select" [items]="mdaList" [hideSelected]="true" bindLabel="description" bindValue="id"
              placeholder="Select Option" formControlName="mdaId" (change)="getMdaRevenue($event)" [clearable]="true"
              [searchable]="true" [multiple]="false" [closeOnSelect]="true" [maxSelectedItems]="1">
            </ng-select>
            <app-error-message controlName="revenueId" label="MDA" [form]="verifyForm"></app-error-message>
          </div>
          <br />
          <div class="col-md-6 tax-input-group">
            <label>Revenue Name</label>
            <ng-select class="ng-select" [items]="mdaExtendedRevenue" [hideSelected]="true" bindLabel="description"
              bindValue="id" placeholder="Select Option" formControlName="revenueCode" (change)="getMdaRecord($event)"
              [clearable]="true" [searchable]="true" [multiple]="false" [closeOnSelect]="true" [maxSelectedItems]="1">
            </ng-select>
            <app-error-message controlName="revenueCode" label="Revenue Code" [form]="verifyForm"></app-error-message>
          </div>
          <br />
          <div class="col-md-6 tax-input-group">
            <label>Amount To Pay</label>
            <input class="tax-form-control" type="text" formControlName="amount" separator />
            <app-error-message controlName="amount" label="Amount To Pay" [form]="verifyForm"></app-error-message>
          </div>
          <br />


          <button [disabled]="verifyForm.invalid" style="
              background: #cc9e0a;
              color: #fff;
              font-weight: 600;
              height: 45px;
            " type="submit">
            Continue
          </button>
        </form>
      </div>
      <div class="input-coat" [ngClass]="{
        'summary-inactive': !asinDetails
      }">
        <div class="input-container">
          <div class="d-flex flex-row align-items-center justify-content-between mb-4">
            <h4 class="mb-0 text-decoration-underline">Taxpayer Details</h4>
            <b class="igr">Anambra State IGR</b>
          </div>

          <div class="w-100">
            <table class="table table-striped table-hover table-bordered mb-0">
              <tr>
                <th class="data-th">ASIN:</th>
                <td class="data-td">{{ asinDetails?.tinNumber || "N/A" }}</td>
              </tr>
              <tr>
                <th class="data-th">NAME:</th>
                <td class="data-td">{{ asinDetails?.displayname ?? "N/A" }}</td>
              </tr>

              <tr>
                <th class="data-th">EMAIL:</th>
                <td class="data-td">{{ verifyForm.get('emailOrPhone').value ?? "N/A" }}</td>
              </tr>
              <tr>
                <th class="data-th">PHONE NUMBER:</th>
                <td class="data-td">{{ verifyForm.get('asin').value ?? "N/A" }}</td>
              </tr>
              <tr>
                <th class="data-th">ADDRESS:</th>
                <td class="data-td">{{ asinDetails?.address ?? "N/A" }}</td>
              </tr>
              <tr>
                <th class="data-th">AMOUNT:</th>

                <div class="d-flex justify-content-end">
                  <h2 style="font-weight: 700; background-color: transparent">
                    {{ amount | currency: "&#8358;" || "N/A" }}
                  </h2>
                </div>
              </tr>
            </table>
          </div>

          <br />
          <div class="d-flex flex-column gap-3"  style="border-top: 1px solid rgb(146, 145, 145); padding-top: 20px;">
            <span style='font-weight: normal; '>Select a payment channel and click on the proceed button to continue to payment</span>
            <div class="payment-methods">
              <label class="payment-method">
                <input type="radio" value="interswitch" name="type" [checked]="true" [disabled]="!asinDetails" name="type"
                  (change)="getType($event)" />
                <img src="assets/img/interswitch-small.png" alt="" />
              </label>
              <label class="payment-method">
                <input value="remita" type="radio" name="type" [disabled]="!asinDetails" (change)="getType($event)" />
                <img src="assets/img/remita.png" alt="" />
              </label>
<!--              <label class="payment-method">-->
<!--                <input value="paystack" type="radio" name="type" [disabled]="!asinDetails" (change)="getType($event)" />-->
<!--                <img src="assets/img/paystack.png" alt="" />-->
<!--              </label>-->
            </div>
          </div>
         

          <br />
          <button [disabled]="!asinDetails || isSubmittingAsinPayment" style="
              background: rgb(33, 138, 123);
              color: #fff;
              font-weight: 600;
              height: 45px;
            " (click)="submit()">
            <span *ngIf="!isSubmittingAsinPayment">PAY</span>
            <div class="spinner-border text-white ms-2" *ngIf="isSubmittingAsinPayment"></div>
          </button>
        </div>
      </div>
    </div>
 
  </div>
</div>
